module.exports = __webpack_public_path__ + "media/images/monster-4276143f4cc6c55481f34fe6520e3044.png";